import styled from 'styled-components';
import { layout, space, color, typography } from 'styled-system';

export const Item = styled.li(() => `
  list-style: none;
  margin-bottom: 0.5rem;
`, layout, space, color, typography);
export const List = styled.ul(() => `
  padding-left: 0;
  margin: 0  0 1rem;
`, layout, space, color, typography);
